import { render, staticRenderFns } from "./PromoWatermarkComponent.vue?vue&type=template&id=76543b0c"
import script from "./PromoWatermarkComponent.vue?vue&type=script&lang=js"
export * from "./PromoWatermarkComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports